import React, { useEffect } from 'react';
import './Snackbar.css';

const Snackbar = ({ show, message, onClose, duration = 3000, type = 'error' }) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [show, duration, onClose]);

    if (!show) return null;

    return (
        <div className={`snackbar ${type} ${show ? 'show' : ''}`}>
            <div className="snackbar-content">
                {type === 'error' && (
                    <svg className="snackbar-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentColor"/>
                    </svg>
                )}
                <span className="snackbar-message">{message}</span>
                <button className="snackbar-close" onClick={onClose}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="currentColor"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default Snackbar;

